/**
 * Lit une date renvoyée par l'API, qui l'exprime en UTC sans le dire.
 *
 * <p>« 2026-09-10T18:13:26 » ne porte aucun marqueur de fuseau, et JavaScript
 * lit alors l'heure comme locale : en Tunisie, 18h13 UTC devient 17h13, et une
 * session qui avait encore trois quarts d'heure devant elle passait pour
 * périmée. L'écran proposait de recommencer un test qui n'était pas fini.</p>
 *
 * <p>Le suffixe n'est ajouté que s'il manque : le jour où l'API datera ses
 * réponses correctement, cette fonction continuera de répondre juste.</p>
 */
export function instantUtc(iso: string): number {
  const porteUnFuseau = /(?:Z|[+-]\d{2}:?\d{2})$/.test(iso);
  return new Date(porteUnFuseau ? iso : `${iso}Z`).getTime();
}
